module.exports = __webpack_public_path__ + "static/media/streetDefault.9efde904.png";